module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.value)
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1784ac19"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/Merger.vue
// module id = 2463
// module chunks = 1